import { MutationTree } from "vuex";
import { RootState } from ".";
import { City } from "./../models/city.model";
import { ToastMessage } from "./../models/toast-message.model";
import { User } from "./../models/user.model";

export const RootMutationTypes = {
  SetToastMessages: "SET_TOAST_MESSAGES",
  SetCities: "SET_CITIES",
  SetUsersSearch: "SET_USERS_SEARCH",
  SetUsers: "SET_USERS"
};

export const mutations: MutationTree<RootState> = {
  [RootMutationTypes.SetToastMessages](state: RootState, payload: ToastMessage | ToastMessage[]) {
    state.toastMessages = payload;
  },
  [RootMutationTypes.SetCities](state: RootState, payload: City[]) {
    state.cities = payload;
  },
  [RootMutationTypes.SetUsersSearch](state: RootState, payload: string) {
    state.userSearch = payload;
  },
  [RootMutationTypes.SetUsers](state: RootState, payload: User[]) {
    state.users = payload;
  }
};
